import { render, staticRenderFns } from "./EditSeniorBill.vue?vue&type=template&id=5f6a1c2e&scoped=true"
import script from "./EditSeniorBill.vue?vue&type=script&lang=js"
export * from "./EditSeniorBill.vue?vue&type=script&lang=js"
import style0 from "./EditSeniorBill.vue?vue&type=style&index=0&id=5f6a1c2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6a1c2e",
  null
  
)

export default component.exports